import { LinkType, urls } from './constans';

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}
export const errorTranslator = (error: string[]) => {
  const firstError = error[0];
  switch (firstError) {
    case 'COMPANY_ALREADY_EXISTS':
      return 'companyExists';

    case 'USER_ALREADY_EXISTS':
      return 'userExists';

    default:
      return 'unknownError';
  }
};

export const validationTranslator = (errorType: 'pattern' | 'required' | 'minLength') => {
  switch (errorType) {
    case 'pattern':
    case 'required':
    case 'minLength':
      return errorType;

    default:
      return 'unknownError';
  }
};

export const handleErrorMessages = (
  errors: Record<string, string[]>,
  notifyErrorFn: (field: any, message: string) => void,
  notifyServerErrorFn: () => void
) => {
  const errs = Object.keys(errors);
  console.dir(errors)
  if (errs.length == 0) {
    notifyServerErrorFn();
    return;
  }
  errs.forEach(errorKey => {
    notifyErrorFn(capitalizeFirstLetter(errorKey), errorTranslator(errors[errorKey]));
  });
};

export const getLinks = (linkType: LinkType, lng?: string) => {
  switch (linkType) {
    case LinkType.howTo:
      if (lng === 'en') return urls.howTo.en;
      return urls.howTo.cs;

    case LinkType.functions:
      if (lng === 'en') return urls.functions.en;
      return urls.functions.cs;

    case LinkType.gdpr:
      if (lng === 'en') return urls.gdpr.en;
      return urls.gdpr.cs;

    case LinkType.logIn:
      return urls.logIn;

    case LinkType.sendAgain:
      return urls.sendAgain;

    default:
      break;
  }
};
